module.exports = __webpack_public_path__ + "static/media/padlock-wizard-unlocked.52e22a1d.svg";